import React, { Component } from "react";
import "../App.css";
import { Button, Form, Spinner } from "react-bootstrap";
import { Redirect } from "react-router-dom";
import password from "../assets/password.svg";
import eye from "../assets/eye.svg";
import eyeslash from "../assets/eyeslash.svg";
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
// import { faEye,faEyeSlash } from '@fortawesome/free-regular-svg-icons'

class Password extends Component {
  constructor(props) {
    super(props);

    this.state = {
      passwordErrorText: "",
      passwordValue: "",
      buttonText: true,
      buttonSpinner: false,
      buttonDisabled: false,
      actionError: "",
      eyeImage: eye,
    };

    this.passwordHandleChange = this.passwordHandleChange.bind(this);

    this.passwordInput = React.createRef();
  }

  loginClick = () => {
    this.setState({ actionError: "" });
    let password = document.getElementById("password");

    if (password.value === "") {
      password.setAttribute("style", "border-color: var(--red1) !important");
      this.setState({ passwordErrorText: "لطفاً رمز عبور خود را وارد کنید" });
      return;
    } else {
      password.setAttribute("style", "border-color: #cfcfcf !important");
      this.setState({ passwordErrorText: "" });
    }

    if (password.value.length >= 6) {
      password.setAttribute("style", "border-color: #cfcfcf !important");
      this.setState({ passwordErrorText: "" });
    } else {
      password.setAttribute("style", "border-color: var(--red1) !important");
      this.setState({ passwordErrorText: "رمز عبور باید حداقل 6 رقم باشد" });
      return;
    }

    this.setState({
      buttonText: false,
      buttonSpinner: true,
      buttonDisabled: true,
    });

    let data = {
      mobile: sessionStorage.getItem("mobile"),
      password: this.state.passwordValue,
      version: "1.0.0",
    };

    fetch("/api/login", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((result) => {
        if (result.status === 200) {
          // console.log(result);
          localStorage.setItem("token", result.token);
          localStorage.setItem("mobile", sessionStorage.getItem("mobile"));
          sessionStorage.clear();
          if (result.notify.length > 0) {
            sessionStorage.setItem("title", result.notify[0].title);
            sessionStorage.setItem("description", result.notify[0].description);
          }
          this.props.history.push("/");
        } else if (result.status === 401) {
          this.setState({
            buttonText: true,
            buttonSpinner: false,
            buttonDisabled: false,
            actionError: "رمز عبور اشتباه است",
          });
        } else {
          this.setState({
            buttonText: true,
            buttonSpinner: false,
            buttonDisabled: false,
            actionError: "ارتباط با سرور برقرار نشد",
          });
        }
      });
  };

  passwordHandleChange(event) {
    this.setState({ passwordValue: event.target.value });
  }

  onForgetPassword() {
    this.setState({ buttonDisabled: true });
    let data = {
      mobile: sessionStorage.getItem("mobile"),
    };

    fetch("/api/forgetPassword", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((result) => {
        if (result.status === 200) {
          // sessionStorage.setItem("token", result.token);
          // alert(result.code);
          sessionStorage.setItem("userStatus", "forget");
          this.props.onForgetPassword();
        } else {
          this.setState({
            buttonDisabled: false,
            actionError: "ارتباط با سرور برقرار نشد",
          });
        }
      });
  }

  componentDidMount() {
    if (
      sessionStorage.getItem("mobile") !== null &&
      sessionStorage.getItem("mobile") !== ""
    ) {
      this.passwordInput.current.focus();
    }
  }

  handleKeyPress(target) {
    if (target.charCode === 13) {
      this.loginClick();
    }
  }

  backPage() {
    this.props.onPasswordBack();
  }

  showPassword() {
    if (this.state.eyeImage === eye) {
      this.setState({ eyeImage: eyeslash }, () => {
        this.passwordInput.current.type = "text";
      });
    } else {
      this.setState({ eyeImage: eye }, () => {
        this.passwordInput.current.type = "password";
      });
    }
  }

  render() {
    if (
      sessionStorage.getItem("mobile") !== null &&
      sessionStorage.getItem("mobile") !== ""
    ) {
      return (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: "100%",
            flexDirection: "column",
            height: "100%",
          }}
        >
          <div className="backButtonContainer" />
          <div style={{ minWidth: "260px", maxWidth: "350px", width: "80%" }}>
            <div className="password">
              {/* <label htmlFor="password">رمز عبور</label> */}
              <label
                style={{ fontSize: "12px", color: "var(--textcolor1)" }}
                htmlFor="code"
              >
                شماره تلفن همراه:&nbsp;&nbsp;{sessionStorage.getItem("mobile")}
              </label>
              <div className="InputWithIcon">
                <div className="inputImageDiv">
                  <img src={password} className="inputImage" alt="mobile" />
                </div>
                <Form.Control
                  className="inputStyle passDirection"
                  placeholder="لطفاً رمز عبور را وارد کنید"
                  type="password"
                  name="password"
                  id="password"
                  onChange={this.passwordHandleChange}
                  value={this.state.passwordValue}
                  disabled={this.state.buttonDisabled}
                  onKeyPress={this.handleKeyPress.bind(this)}
                  ref={this.passwordInput}
                />
                <div
                  className="inputImageDivLeft"
                  onClick={this.showPassword.bind(this)}
                >
                  <img
                    src={this.state.eyeImage}
                    className="inputImage"
                    alt="mobile"
                  />
                </div>
              </div>

              <div className="errorMessage">{this.state.mobileErrorText}</div>
            </div>
            <div className="createAccount">
              <Button
                variant="primary"
                id="btnLogin"
                style={{
                  width: "40%",
                  alignSelf: "flex-end",
                  float: "right",
                  fontSize: "14px",
                  height: "34px",
                }}
                disabled={this.state.buttonDisabled}
                onClick={this.loginClick}
              >
                {this.state.buttonSpinner && (
                  <Spinner
                    style={{ color: "white", height: "20px", width: "20px" }}
                    animation="border"
                  />
                )}
                {this.state.buttonText && <div>ورود</div>}
              </Button>
              <div
                style={{
                  justifyContent: "center",
                  alignItems: "center",
                  display: "flex",
                }}
              >
                <div
                  onClick={
                    this.state.buttonDisabled
                      ? (event) => event.preventDefault()
                      : this.onForgetPassword.bind(this)
                  }
                  className="linkStyle"
                >
                  رمز عبور خود را فراموش کرده‌ام
                </div>
              </div>
            </div>
            {this.state.actionError !== "" && (
              <div className="errorMessageContainer">
                <div>{this.state.actionError}</div>
              </div>
            )}
          </div>
          <div className="backButtonContainer">
            <div className="backButton" onClick={this.backPage.bind(this)}>
              <div>بازگشت</div>
            </div>
          </div>
        </div>
      );
    } else {
      return <Redirect to="/Login" />;
    }
  }
}

export default Password;
